var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"csfg__navbar"},_vm._l((_vm.navigation),function(mode){return _c('span',{key:mode.action,class:[
      'csfg__navbar__button',
      { 'csfg__navbar__button--active': _vm.chosenMode == mode.action },
    ],domProps:{"innerHTML":_vm._s(mode.name)},on:{"click":function($event){return _vm.$emit('choseMode', mode.action)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }